"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightBookingCancelFlightByTmcUserReqCommon = exports.FlightBookingTicketFlightReqCommon = exports.FlightBookingHoldFlightReq = exports.FlightBookingTravelerInfoUpsertReq = exports.FlightBookingTravelerInfoUpsertDtoCommon = exports.ListFlightBookingTxResp = exports.ListFlightBookingTxQueryParams = exports.GetFlightBookingTxResp = exports.FlightBookingDictionaries = exports.RequiredEtag = exports.FlightBookingTxCommon = exports.FlightBookingCancellationDetailsCommon = exports.FlightBookingTicketDetailsCommon = exports.AuditLogElemCommon = exports.FlightBookingTxActorCommon = exports.FlightBookingTxActionCommon = exports.FlightBookingHoldDetailsCommon = exports.FlightBookingTravelerInfoCommon = exports.FlightBookingSelectFlightResp = exports.FlightBookingSelectFlightReq = exports.FlightCommon = exports.GenericRawFlightPriceCommon = exports.GenericRawFlightSegmentCommon = exports.FlightFareTypeCommon = exports.FlightSourceCommon = exports.FlightBookingTxStateCommon = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const pagination_1 = require("./pagination");
var FlightBookingTxStateCommon;
(function (FlightBookingTxStateCommon) {
    FlightBookingTxStateCommon["FLIGHT_SELECTED"] = "FLIGHT_SELECTED";
    FlightBookingTxStateCommon["TRAVELER_INFO_FILLED"] = "TRAVELER_INFO_FILLED";
    FlightBookingTxStateCommon["FLIGHT_HELD"] = "FLIGHT_HELD";
    FlightBookingTxStateCommon["FLIGHT_TICKETED"] = "FLIGHT_TICKETED";
    FlightBookingTxStateCommon["FLIGHT_CONFIRMED"] = "FLIGHT_CONFIRMED";
    FlightBookingTxStateCommon["FLIGHT_COMPLETED"] = "FLIGHT_COMPLETED";
    FlightBookingTxStateCommon["EXPIRED"] = "EXPIRED";
    FlightBookingTxStateCommon["CANCELLED"] = "CANCELLED";
})(FlightBookingTxStateCommon = exports.FlightBookingTxStateCommon || (exports.FlightBookingTxStateCommon = {}));
var FlightSourceCommon;
(function (FlightSourceCommon) {
    FlightSourceCommon["GENERAL"] = "GENERAL";
    FlightSourceCommon["ATPI"] = "ATPI";
    FlightSourceCommon["TMC"] = "TMC";
})(FlightSourceCommon = exports.FlightSourceCommon || (exports.FlightSourceCommon = {}));
var FlightFareTypeCommon;
(function (FlightFareTypeCommon) {
    FlightFareTypeCommon["UNKNOWN"] = "Unknown";
    FlightFareTypeCommon["MARINE"] = "Marine";
    FlightFareTypeCommon["GENERAL"] = "General";
})(FlightFareTypeCommon = exports.FlightFareTypeCommon || (exports.FlightFareTypeCommon = {}));
class GenericRawFlightSegmentCommon {
}
exports.GenericRawFlightSegmentCommon = GenericRawFlightSegmentCommon;
class GenericRawFlightPriceCommon {
}
exports.GenericRawFlightPriceCommon = GenericRawFlightPriceCommon;
class FlightCommon {
}
exports.FlightCommon = FlightCommon;
class FlightBookingSelectFlightReq {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FlightBookingSelectFlightReq.prototype, "flightId", void 0);
exports.FlightBookingSelectFlightReq = FlightBookingSelectFlightReq;
class FlightBookingSelectFlightResp {
}
exports.FlightBookingSelectFlightResp = FlightBookingSelectFlightResp;
class FlightBookingTravelerInfoCommon {
}
exports.FlightBookingTravelerInfoCommon = FlightBookingTravelerInfoCommon;
class FlightBookingHoldDetailsCommon {
}
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], FlightBookingHoldDetailsCommon.prototype, "pnr", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], FlightBookingHoldDetailsCommon.prototype, "dateOfHold", void 0);
exports.FlightBookingHoldDetailsCommon = FlightBookingHoldDetailsCommon;
var FlightBookingTxActionCommon;
(function (FlightBookingTxActionCommon) {
    FlightBookingTxActionCommon["SELECT_FLIGHT"] = "SELECT_FLIGHT";
    FlightBookingTxActionCommon["PUT_TRAVELER_INFO"] = "PUT_TRAVELER_INFO";
    FlightBookingTxActionCommon["HOLD_FLIGHT"] = "HOLD_FLIGHT";
    FlightBookingTxActionCommon["TICKET_FLIGHT"] = "TICKET_FLIGHT";
    FlightBookingTxActionCommon["COMPLETE_FLIGHT"] = "COMPLETE_FLIGHT";
    FlightBookingTxActionCommon["EXPIRE"] = "EXPIRE";
    FlightBookingTxActionCommon["CANCEL"] = "CANCEL";
})(FlightBookingTxActionCommon = exports.FlightBookingTxActionCommon || (exports.FlightBookingTxActionCommon = {}));
var FlightBookingTxActorCommon;
(function (FlightBookingTxActorCommon) {
    FlightBookingTxActorCommon["USER"] = "USER";
    FlightBookingTxActorCommon["TMC"] = "TMC";
    FlightBookingTxActorCommon["AUTOMATED"] = "AUTOMATED";
})(FlightBookingTxActorCommon = exports.FlightBookingTxActorCommon || (exports.FlightBookingTxActorCommon = {}));
class AuditLogElemCommon {
}
exports.AuditLogElemCommon = AuditLogElemCommon;
class FlightBookingTicketDetailsCommon {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Length)(6, 6),
    __metadata("design:type", String)
], FlightBookingTicketDetailsCommon.prototype, "PNR", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], FlightBookingTicketDetailsCommon.prototype, "dateOfIssue", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], FlightBookingTicketDetailsCommon.prototype, "notes", void 0);
exports.FlightBookingTicketDetailsCommon = FlightBookingTicketDetailsCommon;
class FlightBookingCancellationDetailsCommon {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], FlightBookingCancellationDetailsCommon.prototype, "cancellationMsg", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], FlightBookingCancellationDetailsCommon.prototype, "cancellationTime", void 0);
exports.FlightBookingCancellationDetailsCommon = FlightBookingCancellationDetailsCommon;
class FlightBookingTxCommon {
}
exports.FlightBookingTxCommon = FlightBookingTxCommon;
class RequiredEtag {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], RequiredEtag.prototype, "etag", void 0);
exports.RequiredEtag = RequiredEtag;
class FlightBookingDictionaries {
}
exports.FlightBookingDictionaries = FlightBookingDictionaries;
class GetFlightBookingTxResp {
}
exports.GetFlightBookingTxResp = GetFlightBookingTxResp;
class ListFlightBookingTxQueryParams {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(FlightBookingTxStateCommon, { each: true }),
    (0, class_transformer_1.Type)(() => String),
    (0, class_transformer_1.Transform)(({ value }) => value.toString().split(',')),
    __metadata("design:type", Array)
], ListFlightBookingTxQueryParams.prototype, "states", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(['ASC', 'DESC']),
    __metadata("design:type", String)
], ListFlightBookingTxQueryParams.prototype, "departureTimeSort", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Number)
], ListFlightBookingTxQueryParams.prototype, "pageSize", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], ListFlightBookingTxQueryParams.prototype, "pageToken", void 0);
exports.ListFlightBookingTxQueryParams = ListFlightBookingTxQueryParams;
class ListFlightBookingTxResp extends pagination_1.PaginationResp {
}
exports.ListFlightBookingTxResp = ListFlightBookingTxResp;
class FlightBookingTravelerInfoUpsertDtoCommon {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "crewIdentifier", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "gender", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", Object)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "middleName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.Length)(10, 10),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "dob", void 0);
__decorate([
    (0, class_validator_1.IsEmail)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "passportNo", void 0);
__decorate([
    (0, class_validator_1.Length)(10, 10),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "passportIssueDate", void 0);
__decorate([
    (0, class_validator_1.Length)(10, 10),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "passportExpiryDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Length)(2, 2),
    (0, class_validator_1.IsUppercase)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "passportCountryOfIssuanceIso2", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Length)(2, 2),
    (0, class_validator_1.IsUppercase)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "nationalityIso2", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Length)(2, 2),
    (0, class_validator_1.IsUppercase)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "countryOfBirthIso2", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], FlightBookingTravelerInfoUpsertDtoCommon.prototype, "phoneNo", void 0);
exports.FlightBookingTravelerInfoUpsertDtoCommon = FlightBookingTravelerInfoUpsertDtoCommon;
class FlightBookingTravelerInfoUpsertReq extends RequiredEtag {
}
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => FlightBookingTravelerInfoUpsertDtoCommon),
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(9),
    __metadata("design:type", Array)
], FlightBookingTravelerInfoUpsertReq.prototype, "travelerInfos", void 0);
exports.FlightBookingTravelerInfoUpsertReq = FlightBookingTravelerInfoUpsertReq;
class FlightBookingHoldFlightReq extends RequiredEtag {
}
exports.FlightBookingHoldFlightReq = FlightBookingHoldFlightReq;
class FlightBookingTicketFlightReqCommon extends RequiredEtag {
}
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => FlightBookingTravelerInfoUpsertDtoCommon),
    __metadata("design:type", Array)
], FlightBookingTicketFlightReqCommon.prototype, "travelerInfos", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => FlightBookingTicketDetailsCommon),
    __metadata("design:type", FlightBookingTicketDetailsCommon)
], FlightBookingTicketFlightReqCommon.prototype, "ticketDetails", void 0);
exports.FlightBookingTicketFlightReqCommon = FlightBookingTicketFlightReqCommon;
class FlightBookingCancelFlightByTmcUserReqCommon extends RequiredEtag {
}
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => FlightBookingCancellationDetailsCommon),
    __metadata("design:type", FlightBookingCancellationDetailsCommon)
], FlightBookingCancelFlightByTmcUserReqCommon.prototype, "cancellationDetails", void 0);
exports.FlightBookingCancelFlightByTmcUserReqCommon = FlightBookingCancelFlightByTmcUserReqCommon;
var FLIGHT_BOOKING_ERROR_CODES_COMMON;
(function (FLIGHT_BOOKING_ERROR_CODES_COMMON) {
    FLIGHT_BOOKING_ERROR_CODES_COMMON[FLIGHT_BOOKING_ERROR_CODES_COMMON["FLIGHT_ALREADY_SELECTED"] = 1001] = "FLIGHT_ALREADY_SELECTED";
    FLIGHT_BOOKING_ERROR_CODES_COMMON[FLIGHT_BOOKING_ERROR_CODES_COMMON["FLIGHT_NOT_FOUND_IN_CACHE"] = 1002] = "FLIGHT_NOT_FOUND_IN_CACHE";
    FLIGHT_BOOKING_ERROR_CODES_COMMON[FLIGHT_BOOKING_ERROR_CODES_COMMON["TRANSACTION_NOT_FOUND"] = 1003] = "TRANSACTION_NOT_FOUND";
    FLIGHT_BOOKING_ERROR_CODES_COMMON[FLIGHT_BOOKING_ERROR_CODES_COMMON["CREW_IDENTIFIERS_NOT_UNIQUE"] = 1004] = "CREW_IDENTIFIERS_NOT_UNIQUE";
    FLIGHT_BOOKING_ERROR_CODES_COMMON[FLIGHT_BOOKING_ERROR_CODES_COMMON["INVALID_STATE_TRANSITION"] = 1005] = "INVALID_STATE_TRANSITION";
    FLIGHT_BOOKING_ERROR_CODES_COMMON[FLIGHT_BOOKING_ERROR_CODES_COMMON["ETAG_DOES_NOT_MATCH"] = 1006] = "ETAG_DOES_NOT_MATCH";
})(FLIGHT_BOOKING_ERROR_CODES_COMMON || (FLIGHT_BOOKING_ERROR_CODES_COMMON = {}));
